import {
  APPLY_JOB_LIST2_REQUEST, APPLY_JOB_LIST2_FAIL, APPLY_JOB_LIST2_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  //  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const ApplyJobListReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPLY_JOB_LIST2_REQUEST:
      return {
        ...state,
        //  loading: action.payload,
      };
    case APPLY_JOB_LIST2_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        //  loading: action.payload,
        msg: action.msg,
      };
    case APPLY_JOB_LIST2_FAIL:
      return {
        ...state,
        error: action.error,
        //  loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default ApplyJobListReducer;
